import React from "react";
import { Flex, Text } from "rizzui";
import WidgetCard from "../../component/cards/widgetCard";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const data = [
  { name: "Ended by customer", value: 55 },
  { name: "Ended by AI", value: 35 },
  { name: "Ended By AI", value: 10 },
];
const COLORS = ["#B172EC", "#44C2FF", "#8C99AA"];

export default function CallSummary({
  className,
  isEmpty,
}: {
  className?: string;
  isEmpty?: boolean;
}) {
  return isEmpty ? (
    <WidgetCard
      title={"Reason calls ended"}
      headerClassName="hidden"
      className={className}
    >
      <div className="h-[463px] flex justify-center items-center">
        <div className="flex w-[171px] flex-col items-start justify-center gap-[8px]">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            No calls yet
          </Text>
          <Text className="font-switzer font-[400] text-[14px] text-primary-dark">
            Reason why calls end will be here
          </Text>
        </div>
      </div>
    </WidgetCard>
  ) : (
    <WidgetCard
      title={"Reason calls ended"}
      headerClassName="hidden"
      className={className}
    >
      <div className="h-[463px] w-full @sm:py-3">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart className="[&_.recharts-layer:focus]:outline-none [&_.recharts-sector:focus]:outline-none dark:[&_.recharts-text.recharts-label]:first-of-type:fill-white">
            <Pie
              data={data}
              cornerRadius={40}
              innerRadius={70}
              outerRadius={120}
              paddingAngle={10}
              fill="#BFDBFE"
              stroke="rgba(0,0,0,0)"
              dataKey="value"
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div>
        {data.map((item, index) => (
          <Flex
            key={item.name}
            align="center"
            justify="between"
            className="mb-4 gap-0 pb-1 last:mb-0 last:pb-0"
          >
            <Flex align="center" className="gap-0">
              <span
                className="me-2 size-[15px]"
                style={{ backgroundColor: COLORS[index] }}
              />
              <Text
                as="span"
                className="font-switzer text-[14px] font-[400] leading-[18.48px] text-primary-dark"
              >
                {item.name}
              </Text>
            </Flex>
            <Text
              as="span"
              className="font-switzer text-[14px] font-[400] leading-[18.48px] text-[#758599]"
            >
              {item.value}%
            </Text>
          </Flex>
        ))}
      </div>
    </WidgetCard>
  );
}

function CustomLabel(props: any) {
  const { cx, cy } = props.viewBox;
  return (
    <>
      <text
        x={cx}
        y={cy - 5}
        fill="#111111"
        className="recharts-text recharts-label"
        textAnchor="middle"
        dominantBaseline="central"
      >
        <tspan alignmentBaseline="middle" fontSize="36px">
          {props.value1} GB
        </tspan>
      </text>
      <text
        x={cx}
        y={cy + 20}
        fill="#666666"
        className="recharts-text recharts-label"
        textAnchor="middle"
        dominantBaseline="central"
      >
        <tspan fontSize="14px">{props.value2}</tspan>
      </text>
    </>
  );
}
